import React from 'react';
import { cn } from '../../utils';
import AdminFooter from '../ui/AdminFooter';

export interface AdminMainProps {
  children: React.ReactNode;
  /** Limit content width (wide grid dashboard) */
  contentWidth?: 'full' | 'contained';
  className?: string;
}

/**
 * Scrollable admin app body — consistent padding and max-width.
 */
export const AdminMain: React.FC<AdminMainProps> = ({
  children,
  contentWidth = 'full',
  className,
}) => {
  return (
    <main className={cn('flex min-h-0 flex-1 flex-col overflow-hidden', className)}>
      <div
        className={cn(
          'min-h-0 flex-1 overflow-y-auto p-6',
          contentWidth === 'contained' && 'mx-auto w-full max-w-6xl',
        )}
      >
        {children}
      </div>
      <AdminFooter />
    </main>
  );
};

export interface AdminWorkspaceProps {
  children: React.ReactNode;
}

/**
 * Main content column: header (slot) + main + footer.
 * Header is rendered outside this component to keep the current `Header` flexible.
 */
const AdminWorkspace: React.FC<AdminWorkspaceProps> = ({ children }) => {
  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden border-border bg-background lg:border-l">
      {children}
    </div>
  );
};

export default AdminWorkspace;
